/**
 * 体育
 */
import { defineStore } from 'pinia';
import network from '../network';
import { getJSON, setJSON } from '@star/utils';
import { useHot } from '../useHot';
import { useUserStore } from '../user';
import { walletServices } from '../services';

export const useSportsStore = defineStore({
  id: 'sports',
  state: () => {
    return {
      // 用户自定义数据配置
      userConfig: {
        AvailableOddsType: [1, 2, 3, 4], // 1 = 马来盘; 2 = 香港盘; 3 = 欧洲盘; 4 = 印尼盘
        BettingStyle: 1,
        ComboAutoAccept: 1,
        SelectedTimeZone: 29, // 东八区
        FastBetCombo: [1000, 500, 100],
        FastBetSingle: [1000, 500, 100], // 快捷投注值
        SelectedOddsType: 3, // 当前赔率类型
      },
      othersGameHistory: {},
      blance: 0, // 会员余额
      gameBalanceList: getJSON('gameBalanceList', true) || [],
      marking_quantity_sum: 0, // 打码量
      pcLogin: false,
      pcRegister: false,
      canExchangeExperienceGold: 0, // 用户可兑换体验金
    };
  },
  getters: {},
  actions: {
    //  获取余额日志列表
    async reqBalanceLogs(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data: any = {
        tid: tenantInfo.value.tid,
        acct_id: userInfo.value.acct_id,
        ...payload,
      };
      if (payload.sd_flag) {
        // 刷单项目的账变记录需要传1 其他项目 0
        data.sd_flag = payload.sd_flag;
      }
      if (payload.trans_type && payload.trans_type !== '0') {
        // data.trans_type = [];
        data.trans_type = payload.trans_type;
      } else {
        delete data.trans_type;
      }
      if (payload.busi_type && payload.busi_type !== '0') {
        // data.busi_type = [];
        data.busi_type = payload.busi_type.join(',');
      } else {
        delete data.busi_type;
      }
      try {
        const res = await network.request({
          cmdId: 340333,
          data: data,
          headerType: 2,
          paramType: 0,
        });

        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 请求账户余额(汇总)
    async reqBlanceCollect() {
      const { hotData, is_try } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = [tenantInfo.value.tid, userInfo.value.acct_id];
      if (is_try) {
        data = [tenantInfo.value.tid, userInfo.value.acct_id, is_try];
      }

      try {
        // const res: any = await network.request({
        //   cmdId: is_try ? 340235 : 340234,
        //   data: data,
        //   headerType: 2,
        //   paramType: 2,
        // })
        const res: any = await walletServices.reqBlanceCollect(data, is_try ? 340235 : 340234);
        if (res && res.type === 'success') {
          const { experience_gold, experienceGoldSite, balance } = res.data;
          if (is_try) {
            this.blance = experience_gold;
          } else {
            this.blance = balance;
          }
          console.log('canExchangeExperienceGold', res.data);
          let _canExchangeExperienceGold = 0;
          if (experienceGoldSite && experience_gold) {
            const { send_amount, exchange_rate, exchange_multiple, exchange_upper_limit } = experienceGoldSite;
            // 当用户账户的体验金金额 >= 赠送体验金额 * 体验金兑换需满足N倍时，提示用户下载正式环境app兑换奖励，
            // 可兑换金额 = experience_gold / exchange_rate，可兑换金额大于体验金兑换彩金上限， 则取体验金兑换彩金上限
            if (experience_gold >= send_amount * exchange_multiple) {
              _canExchangeExperienceGold = experience_gold / exchange_rate;
              if (_canExchangeExperienceGold > exchange_upper_limit) {
                _canExchangeExperienceGold = exchange_upper_limit;
              }
            }
          }
          this.canExchangeExperienceGold = _canExchangeExperienceGold;
          this.marking_quantity_sum = res.data.marking_quantity_sum;
          if (res.data.level) {
            // 刷新余额时对用户 cust_level 等级刷新
            const userStore = useUserStore();
            userStore.saveUser({ ...userInfo.value, cust_level: res.data.level });
          }
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取所有三方余额
    async reqAllGameBalance() {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data: any = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        data_type: 1,
      };
      const payload = {
        cmdId: 391137,
        data: data,
      };
      console.log(data, 'payload');
      try {
        const res: any = await network.request(payload);
        if (res && res.type === 'success') {
          this.gameBalanceList = res.data;
          setJSON('gameBalanceList', res.data, true);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 一键找回余额
    async reqUpDateBalance(payload) {
      console.log(payload?.play_id, 'payload?.play_id');
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data: any = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        type: payload?.play_id?.includes(',') ? 3 : 1,
        play_id: payload.play_id,
      };
      const payloadData = {
        cmdId: 3911381,
        data: data,
      };
      console.log(payloadData, 'payloadData');
      try {
        const res: any = await network.request(payloadData);
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * @name 转换所有余额
     * @param @requires payload.type 1 只回收上分记录的第三方
     * @param payload.key 本次请求的key，默认为default
     * @param payload.options 更多参数 JSON
     * @param payload.callback 回调 function (res, err) {}
     */
    async reqTransitionAllYe(payload = {}) {
      const { hotData, is_try } = useHot();
      const { tenantInfo, userInfo } = hotData;
      try {
        let data = {
          ...payload,
          tid: tenantInfo.value.tid,
          cust_id: userInfo.value.cust_id,
          type: payload?.play_id?.includes(',') ? 3 : 1,
        };
        const res: any = is_try ? {} : await walletServices.reqTransitionAllYe(data);
        return Promise.resolve(res?.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
  },
});
